<template>
<div>
   <Forms ref="frmSearch"
           title="PESQUISA POR LOTE"
           :showHelp="true"
           :showClearButton="true"
           :showSearchButton="true"
           :showNewButton="false"
           :ShowFooterImbo="true"
           :messageTipFooter="$lang.Common.SelectOrEnterInformationToSearch"
           v-on:Clear="onClearSection"
           v-on:Search="Search"
           >
            <div class="form-group row">
            <label class="label-search">Funcionário</label>
            <autocomplete-z ref="favorecidoTypeahead"
                placeholder="Digite o nome do Funcionário"
                iconClass="fas fa-id-badge"
                :serializer="(favorecido) => favorecido.codigo + ' - ' + favorecido.nome"
                :debounceLength="3"
                :formField="form.funcionarioId"
                :returnCallback="true"
                v-on:search="onSearchFavorecido"
                v-on:changeCode="onChangeCodeFavorecido" />

              <label class="label-search">Lote</label>
              <b-input v-model="form.lote.value" placeholder="Insira o Número do Lote" />

              <div style="width: 100%;">
                <label class="label-search">Data do Lote</label>
                <input type="date" v-model="form.dataLote.value" class="input-date form-control" />
              </div>
            </div>

   </Forms>
</div>
</template>

<script>
import AutocompleteZ from '@/components/forms/AutocompleteZ.vue'
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default {
  name: 'ExpenseSearch',
  components: {AutocompleteZ},
  mixins: [ ActionsForm, ExpenseMixin ],
  data () {
    return {
      dataStatusDespesa: [],
      form: {
        lote: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        dataLote: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        funcionarioId: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        }
      }
    }
  },
  methods: {
    Search () {
      localStoreHelper.viagem.lotesPagos({Lote: this.form.lote.value, DataLote: this.form.dataLote.value, FuncionarioId: this.form.funcionarioId.value})
      this.$emit('search', {Lote: this.form.lote.value, DataLote: this.form.dataLote.value, FuncionarioId: this.form.funcionarioId.value})
    },
    onClearSection () {
      localStoreHelper.viagem.lotesPagos(null)
      this.form.lote.value = null
      this.form.dataLote.value = null
      this.$refs.favorecidoTypeahead.clear()
    }
  }
}
</script>

<style>

@media (max-width: 1920px) {
  .label-search{
    width: 20rem;
    padding-bottom: 0px;
    margin-bottom: 0px;
    margin-top: 10px;
    font-weight: bold;
  }
}
@media (max-width: 1280px) {
  .label-search{
    width: 10rem;
    padding-bottom: 0px;
    margin-bottom: 0px;
    margin-top: 10px;
    font-weight: bold;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/travelexpensezpag/components/Tabs/LotsPaid/components/filterLotsPaid.vue